import { createFileRoute } from '@tanstack/react-router';

import {
    AuditDetails,
    useActionAudit,
} from '@apps/web/features/admin_agent_actions';

export const Route = createFileRoute('/_app/admin/agent/actions/$audit-id')({
    component: ActionAuditDetailRoute,
});

function ActionAuditDetailRoute() {
    const params = Route.useParams();
    const query = useActionAudit(params['audit-id']);
    if (query.isLoading) {
        return (
            <main className="p-6">
                <div
                    aria-label="loading"
                    className="bg-muted h-32 animate-pulse rounded"
                />
            </main>
        );
    }
    if (query.error || !query.data) {
        return (
            <main className="p-6">
                <p role="alert">could not load action audit.</p>
            </main>
        );
    }
    return (
        <main className="mx-auto max-w-4xl p-6">
            <h1 className="mb-4 text-2xl font-semibold">agent action audit</h1>
            <AuditDetails audit={query.data} />
        </main>
    );
}
